enum Roles {
  JOBMARKET_ADMIN = 'IDM_UA_Stellenmarkt_Administrator',
  INCOMINGS_ADMIN = 'IDM_UA_International_Office_Incomings_Portal_Administrator',
  SUPER_USER = 'IDM_UA_Dashboard_Administrator',
  EMPLOYEE_PROFESSOR = 'IDM_Mitarbeiter_Professoren_Gesamt',
  AWPM_ADMIN = 'rp-Gesamt-Dashboard-Wahladmin',
  STUDENT = 'Studenten',
  PROFESSOR = 'Professoren',
  LECTURER = 'Lehrbeauftragte',
  EMPLOYEE = 'Mitarbeiter',
  HIWI = 'Hiwis',
  INCOMING_USER = 'intoffice-user',
  COMPANY_USER = 'jobmarket-user',
  POLYAS_ADMIN = 'rp-Gesamt-Polyas-Wahladmin'
}

export default Roles;
